// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperFinderUpsell-cls1_HDZ","cls2":"PaperFinderUpsell-cls2_Cpy PaperFinderUpsell-cls1_HDZ"};